import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { DropdownOption } from './types';
import { sanitizeText } from './textInput';

interface Props {
  visible: boolean;
  onHide: () => void;
  selectedClass: string | number | null;
  selectedSection: string | null;
  sectionListArr: DropdownOption[];
  onSectionChange: (v: string) => void;
  search: string;
  onSearchChange: (v: string) => void;
  students: any[];
  selectedStudents: any[];
  onSelectionChange: (v: any[]) => void;
  isAdding: boolean;
  onAddSelected: () => void;
}

const AddStudentDialog: React.FC<Props> = (p) => (
  <Dialog
    header="Add Student Class-12"
    visible={p.visible}
    modal
    draggable={false}
    closeOnEscape={false}
    blockScroll
    className="size"
    onHide={p.onHide}
  >
    <div className="row g-3 mt-1">
      <div className="col-md-4">
        <label className="form-label">Section</label>
        <Dropdown
          options={p.sectionListArr}
          value={p.selectedSection}
          onChange={(e) => p.onSectionChange(e.value)}
          placeholder="Select Section"
          filter
          filterBy="label"
          showClear
          appendTo={document.body}
          className="w-100"
        />
      </div>
      <div className="col-md-4">
        <label className="form-label">Search</label>
        <input
          type="text"
          placeholder="Search EmisId"
          className="form-control"
          value={p.search}
          onChange={(e) => p.onSearchChange(sanitizeText(e.target.value))}
        />
      </div>
    </div>

    {p.selectedClass && p.selectedSection && (
      <div className="row mt-3">
        <div className="col-12">
          <DataTable
            value={p.students}
            dataKey="user_id"
            selection={p.selectedStudents}
            onSelectionChange={(e) => p.onSelectionChange(e.value as any[])}
            isDataSelectable={(e) => !e.data?.alreadyAdded}
            rowClassName={(row) =>
              row.alreadyAdded ? 'row-already-added' : ''
            }
            responsiveLayout="scroll"
            paginator
            rows={10}
            emptyMessage="No Records Found"
            stripedRows
            showGridlines
            size="small"
            className="prime-table"
            globalFilter={p.search}
            globalFilterFields={[
              'user_id',
              'name',
              'class_studying_id',
              'class_section',
              'section',
            ]}
          >
            <Column
              selectionMode="multiple"
              headerStyle={{ width: '3rem' }}
              bodyClassName="text-center"
            />
            <Column
              header="S.No"
              body={(_r, { rowIndex }) => rowIndex + 1}
              headerClassName="text-center"
              bodyClassName="text-center"
              style={{ width: '4rem' }}
            />
            <Column
              field="user_id"
              header="EMIS Id"
              bodyClassName="text-center"
            />
            <Column field="name" header="Name" bodyClassName="text-center" />
            <Column
              field="class_studying_id"
              header="Class"
              bodyClassName="text-center"
              style={{ width: '5rem' }}
            />
            <Column
              header="Section"
              body={(row) => row.class_section || row.section || '--'}
              bodyClassName="text-center"
              style={{ width: '6rem' }}
            />
            <Column field="dob" header="DOB" bodyClassName="text-center" />
            <Column
              header="Status"
              body={(row) => (
                <Tag
                  value={row.alreadyAdded ? 'Added' : 'Available'}
                  severity={row.alreadyAdded ? 'success' : 'info'}
                />
              )}
              bodyClassName="text-center"
              style={{ width: '7rem' }}
            />
          </DataTable>
        </div>
      </div>
    )}

    <div className="d-flex justify-content-end align-items-center gap-2 mt-3">
      <Button
        type="button"
        label="Cancel"
        className="p-button-outlined p-button-secondary"
        onClick={p.onHide}
      />
      <Button
        type="button"
        label="Add Selected"
        icon="pi pi-check"
        loading={p.isAdding}
        disabled={!p.selectedStudents.length}
        onClick={p.onAddSelected}
      />
    </div>
  </Dialog>
);

export default AddStudentDialog;
